module.exports = __webpack_public_path__ + "static/topography_right-287726e90e12df387387cb6b6f423c98.png";